import axios from 'axios';
import { API_URL } from '../config';

export const getCitiesList = async (token: string, q: string | null) => {
  const params: Record<string, any> = {};

  if(q)
    params['q'] = q;

    const response = await axios.get(`${API_URL}/presenze/resources/cities/?${new URLSearchParams(params).toString()}`, {
      headers: {
        'Authorization': token,
      }
    });
    return response.data;
};

export const getCitizenshipsList = async (token: string, q: string | null) => {
    const params: Record<string, any> = {};

    if(q)
      params['q'] = q;

    const response = await axios.get(`${API_URL}/presenze/resources/citizenships/?${new URLSearchParams(params).toString()}`, {
      headers: {
        'Authorization': token,
      }
    });
    return response.data;
};

export const getClassificationLevelList = async (token: string, ccnlId: number, q: string | null) => {
  const params: Record<string, any> = {};

  if(q)
    params['q'] = q;

  const response = await axios.get(`${API_URL}/presenze/resources/classification-level/?ccnl_id=${ccnlId}&${new URLSearchParams(params).toString()}`, {
    headers: {
      'Authorization': token,
    }
  });
  return response.data;
};

export const getEducationLevelsList = async (token: string, q: string | null) => {
  const params: Record<string, any> = {};

    if(q)
      params['q'] = q;

  const response = await axios.get(`${API_URL}/presenze/resources/education-levels/?${new URLSearchParams(params).toString()}`, {
    headers: {
      'Authorization': token,
    }
  });
  return response.data;
};

export const getMandatoryHiringTypesList = async (token: string) => {
  const response = await axios.get(`${API_URL}/presenze/resources/mandatory-hiring-types`, {
    headers: {
      'Authorization': token,
    }
  });
  return response.data;
};

export const getPoliceHeadQuartersList = async (token: string, q: string | null) => {
  const params: Record<string, any> = {};

  if(q)
    params['q'] = q;

  const response = await axios.get(`${API_URL}/presenze/resources/police-headquarters/?${new URLSearchParams(params).toString()}`, {
    headers: {
      'Authorization': token,
    }
  });
  return response.data;
};

export const getResidencePermitReasonsList = async (token: string, q: string | null) => {
  const params: Record<string, any> = {};

  if(q)
    params['q'] = q;

  const response = await axios.get(`${API_URL}/presenze/resources/residence-permit/reasons/?${new URLSearchParams(params).toString()}`, {
    headers: {
      'Authorization': token,
    }
  });
  return response.data;
};

export const getResidencePermitTypesList = async (token: string, q: string | null) => {
  const params: Record<string, any> = {};

  if(q)
    params['q'] = q;

  const response = await axios.get(`${API_URL}/presenze/resources/residence-permit/types/?${new URLSearchParams(params).toString()}`, {
    headers: {
      'Authorization': token,
    }
  });
  return response.data;
};

export const getWorkTaskList = async (token: string, q: string | null) => {
  const params: Record<string, any> = {};

  if(q)
    params['q'] = q;

    const response = await axios.get(`${API_URL}/presenze/resources/work-tasks/?${new URLSearchParams(params).toString()}`, {
      headers: {
        'Authorization': token,
      }
    });
    return response.data;
};

export const getEntePrevidenzialeList = async (token: string, q: string | null) => {
  const params: Record<string, any> = {};

  if(q)
    params['q'] = q;

  const response = await axios.get(`${API_URL}/presenze/resources/social-security-institutions/?${new URLSearchParams(params).toString()}`, {
    headers: {
      'Authorization': token,
    }
  });
  return response.data;
};

export const getWorkingHourTypesList = async (token: string, q: string | null) => {
  const params: Record<string, any> = {};

  if(q)
    params['q'] = q;

  const response = await axios.get(`${API_URL}/presenze/resources/working-hours-types/?${new URLSearchParams(params).toString()}`, {
    headers: {
      'Authorization': token,
    }
  });
  return response.data;
};
